import { post, get, put } from '@/apis'
import { ValidateQustionPayload } from '@/models/student/question'
import { ResetPasswordPayload, RegisterPayload } from '@/models/student'

/**
 * 注册
 * @param payload 学生信息
 */
export async function createStudent(payload: RegisterPayload) {
  await post(`student`, payload)
}

/**
 * 获取密保问题
 * @param IdNumber 身份证号码
 */
export async function fetchQustion(IdNumber: string) {
  const { data } = await get(`student/question/${IdNumber}`)
  return data
}

/**
 * 校验密保问题答案
 * @param payload 身份证/密保答案
 */
export async function validateQustion(payload: ValidateQustionPayload) {
  await post(`student/question`, payload)
}

export async function resetPassword(payload: ResetPasswordPayload) {
  await put(`student/password`, payload)
}
